import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import { AuthUserContext } from '../Session';

const Navigation = () => (
  <div>
    <AuthUserContext.Consumer>
      { authUser =>
        authUser ? <NavigationAuth /> : null
      }
    </AuthUserContext.Consumer>
  </div>
);

const NavigationAuth = () => (
  <div>
    <ul>
      <li>
        <Link to={ROUTES.GRAPH}>Graph Builder</Link>
      </li>
      <li>
        <Link to={ROUTES.CONTACTS}>Contacts</Link>
      </li>
    </ul>
  </div>
);
export default Navigation;
